interface SpinnerProps {
	/** 外径 (px)。 */
	size?: number;
	/** 回る部分の色。既定は --accent-solid。 */
	color?: string;
	"data-testid"?: string;
}

/** 処理待ちを示す回転インジケータ。 */
export function Spinner({
	size = 12,
	color = "var(--accent-solid)",
	"data-testid": testId,
}: SpinnerProps) {
	return (
		<span
			data-testid={testId}
			style={{
				display: "inline-block",
				width: size,
				height: size,
				flexShrink: 0,
				borderRadius: "var(--radius-full)",
				border: `${size <= 12 ? 1.5 : 2}px solid var(--line-1)`,
				borderTopColor: color,
				animation: "izanagi-spin 0.9s linear infinite",
			}}
		/>
	);
}
